/**
 * Shopify Taste Theme - Premium & Clean Custom Behaviors
 * Handles dynamic animations, scroll reveal effects, and utility features.
 */

(function () {
  'use strict';

  // Initialize all custom premium features
  function initPremiumFeatures() {
    initScrollReveal();
    initBackToTop();
    initHeaderEffects();
  }

  // 1. Scroll Reveal Animations (Intersection Observer)
  function initScrollReveal() {
    const animationTargets = [
      '.grid__item',
      '.multicolumn-list__item',
      '.collage__item',
      '.image-with-text',
      '.rich-text',
      '.collection-hero__text-wrapper',
      '.featured-blog__title',
      '.contact-form'
    ];

    const elementsToReveal = document.querySelectorAll(animationTargets.join(', '));
    
    if (elementsToReveal.length === 0) return;

    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -50px 0px', // Trigger when element is 50px inside viewport
      threshold: 0.05
    };

    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target); // Animate only once
        }
      });
    }, observerOptions);

    // Apply animation classes and start observing
    elementsToReveal.forEach((el, index) => {
      el.classList.add('premium-reveal');
      
      // Add a slight stagger effect for elements that are horizontal siblings
      const siblingIndex = Array.from(el.parentNode.children).indexOf(el);
      if (siblingIndex > 0 && siblingIndex < 4) {
        el.style.transitionDelay = `${siblingIndex * 0.1}s`;
      }
      
      revealObserver.observe(el);
    });
  }

  // 2. Back to Top Button
  function initBackToTop() {
    const backToTopBtn = document.getElementById('back-to-top');
    if (!backToTopBtn) return;

    // Toggle button visibility based on scroll position
    window.addEventListener('scroll', () => {
      if (window.scrollY > 300) {
        backToTopBtn.classList.add('visible');
      } else {
        backToTopBtn.classList.remove('visible');
      }
    }, { passive: true });

    // Smooth scroll back to top on click
    backToTopBtn.addEventListener('click', (e) => {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }

  // 3. Header Scrolling Effects
  function initHeaderEffects() {
    const headerWrapper = document.querySelector('.header-wrapper');
    if (!headerWrapper) return;

    let lastScrollY = window.scrollY;

    window.addEventListener('scroll', () => {
      const currentScrollY = window.scrollY;
      
      // Add scrolled class when user scrolls down
      if (currentScrollY > 50) {
        headerWrapper.classList.add('header-scrolled');
      } else {
        headerWrapper.classList.remove('header-scrolled');
      }

      lastScrollY = currentScrollY;
    }, { passive: true });
  }

  // Run on DOM Ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPremiumFeatures);
  } else {
    initPremiumFeatures();
  }

  // Re-run if in Shopify Theme Editor (design mode) to ensure animations work when customizing
  document.addEventListener('shopify:section:load', () => {
    // Re-initialize to capture new or re-rendered elements
    initScrollReveal();
  });
})();
